import SuggestionsContainer from './SuggestionsContainer'

export default  SuggestionsContainer